import styled from "styled-components"

const RssTitle = styled.a`
  color: rgba(0, 0, 0, 0.8);
  & > h3::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`

const RssContent = styled.ul`
  & > li {
    border-bottom: 1px solid black;
    & > a {
      color: black;
      & > h4 {
        &::before {
          background-color: ${(props) => props.theme.b_color_gradients.b_dark};
        }
      }
    }
  }
`
const RssCategories = styled.ul`
  color: black;
  & > li {
    border: 1px solid black;
    background-color: white;
    & > a {
      color: inherit;
    }
    &:hover {
      color: ${(props) => props.theme.b_color_gradients.b_dark};
      border-color: ${(props) => props.theme.b_color_gradients.b_dark};
    }
  }
`

export { RssCategories, RssTitle, RssContent }
